import { Injectable } from '@angular/core';
import { GeneralConfigService, User, UserService } from '@inera/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DefaultRouteGuard {
  private user: User;
  private secured = true;
  private secured$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private userService: UserService,
    private configService: GeneralConfigService
  ) {
    this.userService.connect().subscribe(user => {
      this.user = user;
    });
    this.configService.getConfig().subscribe(config => {
      this.secured = config.secured;
      this.secured$.next(config.secured);
    });

    this.secured$.subscribe(value => {
      if (!value) {
        this.userService.getUser().subscribe(user => {
          this.user = user;
        });
      }
    });
  }

  public canActivate(): boolean {
    if (!this.secured) {
      return true;
    }
    if (this.user) {
      return true;
    } else {
      return false;
    }
  }

  public checkIfAuthorizedWithRoles(roles: string[]): boolean {
    const systemRoles = new Set(
      Object.values(this.user?.privileges).flatMap(roleSet => {
        return roleSet.name;
      })
    );

    if (roles.some(role => systemRoles?.has(role))) {
      return true;
    }

    return false;
  }
}
